const MONTHS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
const DAYS = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];

export const parseDay = (value) => {
  if (!value) return null;
  const date = new Date(`${String(value).slice(0, 10)}T00:00:00`);
  return Number.isNaN(date.getTime()) ? null : date;
};

const shortDate = (value) => {
  const date = parseDay(value);
  if (!date) return '';
  return `${date.getDate()} ${MONTHS[date.getMonth()]}`;
};

export const formatSaisie = (value) => {
  if (!value) return '';
  const date = new Date(String(value).replace(' ', 'T'));
  if (Number.isNaN(date.getTime())) return '';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${day}/${month}`;
};

export const formatSaisieLong = (value) => {
  if (!value) return '';
  const date = new Date(String(value).replace(' ', 'T'));
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
};

export const eventDateParts = (item) => {
  const start = parseDay(item?.dateDeDebut);
  const end = parseDay(item?.dateDeFin);
  if (!start) return { main: '—', sub: '', ongoing: false };
  const same = !end || end.getTime() === start.getTime();
  const main = same
    ? shortDate(item.dateDeDebut)
    : `${shortDate(item.dateDeDebut)} → ${shortDate(item.dateDeFin)}`;
  let sub = DAYS[start.getDay()];
  if (!same && end) {
    const days = Math.round((end.getTime() - start.getTime()) / 86400000) + 1;
    sub = `sur ${days} jours`;
  } else if (item?.heureDeDebut) {
    sub = `${sub} · ${String(item.heureDeDebut).slice(0, 5)}`;
  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const last = end || start;
  return { main, sub, ongoing: start <= today && today <= last };
};

const asNumber = (value) => {
  const raw = String(value ?? '').trim().replace(',', '.');
  if (raw === '') return null;
  const number = Number(raw);
  return Number.isFinite(number) ? number : raw;
};

export const prixLabel = (min, max) => {
  const a = asNumber(min);
  const b = asNumber(max);
  const empty = (value) => value === null || value === '';
  const free = (value) => value === 0;
  const libre = (value) => typeof value === 'string' && value.toLowerCase() === 'libre';
  if (empty(a) && empty(b)) return { text: '—', tone: 'muted' };
  if (libre(a) || libre(b)) return { text: 'Prix libre', tone: 'ink' };
  if ((empty(a) || free(a)) && (empty(b) || free(b))) return { text: 'Gratuit', tone: 'free' };
  if (!empty(a) && !empty(b) && a !== b) return { text: `${min} – ${max} €`, tone: 'ink' };
  return { text: `${empty(a) ? max : min} €`, tone: 'ink' };
};

export const matchPrix = (item, filter, maxEuro) => {
  if (!filter || filter === 'all') return true;
  const a = asNumber(item?.prixMinimum);
  const b = asNumber(item?.prixMaximum);
  const empty = (value) => value === null || value === '';
  const libre = (value) => typeof value === 'string' && value.toLowerCase() === 'libre';
  const gratuit = (value) => typeof value === 'string' && value.toLowerCase() === 'gratuit';
  const numeric = (value) => typeof value === 'number' ? value : null;
  if (libre(a) || libre(b)) return filter === 'libre';
  const min = numeric(a);
  const max = numeric(b);
  const explicitFree = gratuit(a) || gratuit(b) || min === 0 || max === 0;
  const noPrice = (empty(a) || gratuit(a)) && (empty(b) || gratuit(b)) && (min === null || min === 0) && (max === null || max === 0);
  if (filter === 'free') return explicitFree && noPrice;
  if (filter === 'paid') return (min !== null && min > 0) || (max !== null && max > 0);
  if (filter === 'max') {
    const cap = Number(String(maxEuro ?? '').replace(',', '.'));
    if (!Number.isFinite(cap)) return true;
    if (explicitFree && noPrice) return true;
    if (min !== null) return min <= cap;
    if (max !== null) return max <= cap;
    return false;
  }
  return true;
};

export const formatWhen = (form) => {
  const start = parseDay(form?.dateDeDebut);
  if (!start) return '';
  const long = (date) => date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
  const end = parseDay(form.dateDeFin);
  const dates = end && end.getTime() !== start.getTime()
    ? `Du ${long(start)} au ${long(end)}`
    : long(start);
  const h1 = form.heureDeDebut ? String(form.heureDeDebut).slice(0, 5).replace(':', 'h') : '';
  const h2 = form.heureDeFin ? String(form.heureDeFin).slice(0, 5).replace(':', 'h') : '';
  const hours = h1 ? (h2 && h2 !== h1 ? `${h1} – ${h2}` : h1) : '';
  return [dates, hours].filter(Boolean).join(' · ');
};
